/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RightBuccalNoRetractors/view.blocks to change it.
import React from 'react'
import sourceJpg from "./source.jpg"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RightBuccalNoRetractors({
  children,
  viewPath = "/DesignSystem/Images/RightBuccalNoRetractors",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 282,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourceJpg,
  width = 602
  
}) {
  return (<React.Fragment
>
<img
  data-testid="RightBuccalNoRetractors.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z7JH0X': alignSelf,'--bc-2-Z7JH0X': backgroundColor,'--bblr-3-Z7JH0X': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z7JH0X': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z7JH0X': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z7JH0X': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z7JH0X': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z7JH0X': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z7JH0X': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z7JH0X': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z7JH0X': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z7JH0X': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}